import { StatsDetailsTabEnum } from '@/features/gateway/types'
import { useCurrentReflection } from '@/hooks'
import { useApiQuery } from '@/utils/use-api-query'
import { $t } from 'packages/locale'
import { FC, useContext } from 'react'

import { IndexBoardCard } from '../components/IndexBoardCard'
import { DataBoardContext } from '../context'
import { useStatsApiQuery } from '../utils/query'
import { getDeviceCardTips } from '../utils/tips'

/**
 * 静校管理统计卡片
 *
 * @returns SilentCard component
 */
export const SilentCard: FC = () => {
  const { semesterInfo, timeRange, role } = useContext(DataBoardContext)
  const reflection = useCurrentReflection()

  const apiQuery = useStatsApiQuery({
    timeRange,
    semesterInfo,
  })

  const { data: res, loading } = useApiQuery({
    apiName: 'queryAdvisorStudentSilentAssessmentStats',
    params: {
      query: apiQuery,
    },
    options: {
      enabled: !!reflection?.usin,
    },
  })

  const { data: silentStats } = res || {}

  return (
    <IndexBoardCard
      title={$t('静校管理统计')}
      count={silentStats?.at(0)?.total_user_count ?? 0}
      items={[]}
      flex={1}
      type={StatsDetailsTabEnum.StudentStaticManagement}
      loading={loading}
      tips={getDeviceCardTips(role)}
      itemIconMsg={{
        name: 'BellSimpleZ',
        color: '#00AAFF',
        backgroundColor: '#E8FBFF',
      }}
    />
  )
}
